module.exports = __webpack_public_path__ + "img/Exit.dacd4363.png";